import React from 'react'

import { Page, ShelfLifeLogo, Text } from '@fielded/shared-ui'

import LoginIntercomLink from './LoginIntercomLink'
import {
  isPsmCoreApp,
  isPsmResellerApp,
  isShelflifeCoreApp,
  isShelflifeResellerApp
} from '../van-shared/utils/utils'

export const ResellerLogoWrapper = ({ config }) => (
  <h1 className='login__logo'>
    <span className='vs-u-visually-hidden'>{config.name}</span>
    {config.logoUrl && (
      <img src={config.logoUrl} alt='Logo' className='login__logo' />
    )}
  </h1>
)

const EntryViewWrapper = ({ children, config, showIntercom = false }) => {
  const {
    name,
    shortName,
    program
  } = config

  const isShelflifeCore = isShelflifeCoreApp(config)
  const isPsmCore = isPsmCoreApp(config)

  const isShelflifeReseller = isShelflifeResellerApp(config)
  const isPsmReseller = isPsmResellerApp(config)

  const loginProgramHead = (
    <div className='login__intro'>
      {isShelflifeCore && (
        <h1 className='login__logo'>
          <ShelfLifeLogo fill='#fff' />
        </h1>
      )}

      {isPsmCore && (
        <Text.Heading className='login__app-name'>
          {name} {`(${shortName})`}
        </Text.Heading>
      )}

      {(isShelflifeReseller || isPsmReseller) && (
        <ResellerLogoWrapper config={config} />
      )}

      {program && (
        <Text.Heading className='login__program'>{program}</Text.Heading>
      )}
    </div>
  )

  return (
    <div className='login'>
      <Page
        situation='ready'
        className='login__main'
        contentClassName='login__main-inner'
        title={config.title}
      >
        {isShelflifeCore && (<div className='login__texture' />)}
        {loginProgramHead}

        <Page.Panel
          withBackground
          withMargin
          className='login__panel'
        >
          {children}
        </Page.Panel>

        {showIntercom && (
          <LoginIntercomLink config={config} />
        )}
      </Page>
    </div>
  )
}

export default EntryViewWrapper
